import { useEffect, useState } from 'react'

const TAILWIND_MD = '(min-width: 768px)'
const TAILWIND_XL = '(min-width: 1280px)'

export const useDevice = () => {
	const [isTablet, setIsTablet] = useState(false)
	const [isDesktop, setIsDesktop] = useState(false)

	useEffect(() => {
		const mediaDesktop = window.matchMedia(TAILWIND_MD)
		const mediaTablet = window.matchMedia(TAILWIND_XL)
		if (mediaDesktop.matches !== isDesktop) {
			setIsDesktop(mediaDesktop.matches)
		}

		if (mediaTablet.matches !== isTablet) {
			setIsTablet(mediaTablet.matches)
		}
		const listener = () => {
			setIsDesktop(mediaDesktop.matches)
			setIsTablet(mediaTablet.matches)
		}
		window.addEventListener('resize', listener)
		return () => window.removeEventListener('resize', listener)
	}, [isDesktop, isTablet])

	return { isDesktop, isTablet }
}
